module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Chapter One")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("April")])])])]), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("“…And I will sleep in peace until you come to me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I hope you find peace, Dad.” Edward Kincaid turned away from the funeral service in the distance and limped back up the sloping hill of Mt. Washington Cemetery to his own hell. It wasn’t the first time he’d been to a ceremony to bury a fellow cop. But it was the first time he’d shown up for one without wearing his own uniform or badge. And it was the first time he’d shown up to bury his own father. “I don’t know how. But I hope you do.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Edward couldn’t feel the cold rain seeping through his hair and running down his scalp. But he felt the chill of the April day down in his knitted bones. He could barely make out the lyrics of the song his youngest brother, Holden, was singing. But he felt the mournful melody deep in his soul.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His mother and brothers, colleagues from the KCPD and more family friends than he could count were gathered on the opposite side of the copse of evergreens and ash trees to his back. But here were the only two people he wanted to be with right now. With his cane sinking into the mud, he awkwardly knelt down in front of the pink marble gravestone and wiped the rain away from the words carved there.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Beloved Wife. Beloved Daughter.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cara and Melinda Kincaid. He should be in the ground beside them. Instead of them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Tears burned in his eyes, but he didn’t shed them. He was all cried out months ago.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He heard the minister talking. He’d gotten this far. If he was going to do this thing, if he was going to face those mourners, he’d better get moving.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I can’t stay today, girls,” he whispered. The thick, moist air swallowed up the gravelly rasp of his voice. “But I wanted…I wanted you to know that I’m sober today. I’m doing it for Dad. I wish I’d been strong enough to get my act together for you. I’m going to do right by him—by you, too. I threw out the bottles the night I got the call about…his murder. That’s five days sober. I’m going to make it one more.” One day at a time was what his AA sponsor kept telling him. One day was about all he had in him anymore. “I promise.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Melinda would have jumped up and thrown herself into his arms to congratulate him. Despite her young age and her disability, his daughter had always been intuitive about moods. She knew when her daddy needed a hug, when he needed to be left alone, and when he needed someone to cheer him on and make him smile.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Five days without a drink wasn’t much for a man who’d been trying to numb his brain and heart since Christmas Eve, the first anniversary of their deaths. But Melinda’s pure love would have made him feel as though five days was the entire world. Cara would have been a little more low-key about the whole thing, saying something that would keep him from getting a big head about his accomplishment. And later, she’d find a way to congratulate him privately, personally—and very thoroughly. His two girls would have inspired him to live better than he had been, try harder than he knew how, feel more than he’d ever thought possible.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("If only his wife and daughter were still with him. He didn’t want to be at the cemetery. He didn’t want to accept another death—especially not this one. He didn’t want to feel a damn thing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But he owed his father a hell of a lot more than drinking himself stupid and not showing up for his funeral.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I want you to look for Grandpa, angel.” Leaning heavily on his cane, Edward pushed himself up to his feet. “Grandpa’s coming to see you, he missed you so much. Give him a hug.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His canvas jacket was soaked and clinging to his shoulders before he could finally tear himself away from the memories and guilt. But once his mind was back in the present, Edward turned his ear toward the ceremony continuing just thirty yards or so behind him. Holden had finished his song, and KCPD’s lady commissioner was speaking now, eulogizing his father. “Deputy Commissioner John Kincaid was the finest example of what being a Kansas City police officer is all about.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Edward nodded in silent agreement and cut through the trees to study the sea of umbrellas and listen to the remainder of the service. The world itself was weeping at the injustice of the day. John Kincaid had inspired him to join KCPD. He’d taught Edward how to be a cop, a man, and a father—teaching by example. Edward had already lost more than he could stand when his wife and daughter were murdered. How was he supposed to deal with his father being beaten and shot to death as well?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The world made no sense. What was the point of following the rules and fighting for justice and giving a damn when the bad guys still won?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Back when he’d been an active-duty investigator and undercover cop for KCPD, he’d dealt with violence and death nearly every day, but he’d been able to remain detached and focused enough to get his job done. But then he’d lost Cara and Melinda, and death had become an inescapable, personal, destructive demon. Now his father, a good man—the man he’d once aspired to be—had been murdered as well.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("How many pieces of his soul did a man have in him to lose?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Commissioner Shauna Cartwright finished her eulogy, and the blue KCPD uniforms all bowed their heads for the minister’s closing prayer. The twenty-one gun salute visibly jolted through his mother, Susan Kincaid, whom he could see sitting between two of his brothers—Atticus and Holden. His brothers wore their full dress KCPD uniforms with black mourning ribbons draped across the badges on their chests. He searched beyond the green awning to find his next eldest brother, Sawyer, standing hatless in the rain. He wore KCPD dress as well. Sawyer stood next to William Caldwell, one of their family’s oldest friends. Bill was leaning in, offering some condolence or words of wisdom that Sawyer would hear but not take, especially if the words involved "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("patience")])]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("let someone else handle this.")])]), _vm._v(" Bill Caldwell was like an uncle to them—having been a fraternity brother of their father’s and fishing buddy before any of John Kincaid’s sons were even born.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Edward was looking at a family in stoic devastation. It wasn’t a world that he’d ever wanted to welcome them to.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What the…?” Edward pulled his shoulders back and stood a little taller. “Don’t do this, Atticus.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It was one thing to feel the emptiness and injustice of the day. It was another to have to put words to it and deal with anybody else’s pain. But his brother had broken away from the gathering and was striding straight toward him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Atticus’s gray eyes matched his, as determined to have this conversation as Edward wished he could avoid it. Stubborn son of a gun. Atticus wasn’t a man he could glare away. Not if the proffered hand was any indication.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Don’t tell me you don’t recognize what this means, Edward. It’s good to see you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The idea of turning around and walking away remained a distinct possibility. But the idea of explaining his cowardice to Cara or Melinda, who rested only a few yards away, was even more untenable. So he reached out and shook Atticus’s hand, grudgingly reconnecting with his family. Grief and anger and understanding passed between them. “Don’t you dare try to hug me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Atticus almost laughed at his grinch-like reply. But this wasn’t a day for laughter. Instead, his younger brother turned and stood beside him, watching as friends and family dispersed, ducking under umbrellas and walking down the hill toward their cars.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("They stood together, like the old days, back when John Kincaid’s four sons had been invincible. Those days were long gone—for Edward, at least. The soft patter of the rain on the overhanging trees should have been a soothing sound. But Edward heard each plop against every branch like the ticking of a clock. Atticus didn’t do anything without a purpose, and he seriously doubted that this reunion was just a “Hey—how are you doing?” moment.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You should come say hi to Mom. She knows you’re here, but it’d mean a lot to her if you made the effort to touch base.” He should have suspected Atticus’s mission before he spoke. “She’s hurting. We all are.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Welcome to my hell")])]), _vm._v(".")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But it was a sentiment he would never utter aloud to his grieving brother. Edward inhaled a deep breath and tried to say something appropriately sympathetic. “I’m sure Mom has invited people over to the house, but I can’t do the small-talk thing. Just give her my love.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Give it to her yourself. Let me get Sawyer and Holden on this. We’ll keep everyone away and you can have a private moment with her before she leaves Mt. Washington.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Atticus, I…” "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Grandma needs a hug, too")])]), _vm._v(". Edward ducked his head and turned away as his daughter’s sweet voice tormented his conscience.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He could wallow in grief and anger all he wanted. But he’d never been able to say no to his little girl.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His mother needed him right now. His family needed him. Edward had nothing left to give, nothing left to say. But for Cara and Melinda—and for John Kincaid—he’d find the strength to at least go through the motions. He’d find the caring that had been gutted from him somewhere along the way.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ll meet you by her car in ten minutes.”")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("“W"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("HEN")])]), _vm._v(" I "), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("GAVE YOU BOYS")])]), _vm._v(" literary names, I didn’t think you’d take them to heart.” Susan Kincaid, dedicated English teacher and loving wife and mother, patted Edward’s knee as she scooted closer beside him in the rear seat of the funeral home’s limousine, still parked on the road that twisted through Mt. Washington cemetery. “Edward Rochester Kincaid—just like Jane Eyre’s Mr. Rochester—you’ve been burned so badly by the world that you feel your only comfort is to hide away from it. He didn’t find peace until he was forced from his seclusion by Jane. He didn’t understand how much he was loved and needed, either.” Resting one hand on the folded American flag that sat in her lap, she reached over and laced her fingers together with Edward’s. “These are hellish circumstances to force you from your seclusion. But I’m so glad you’re here, son. It…soothes me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Soothing? Edward was shaking inside his skin with raw emotion and the uncertainty about what he should—and could—do to help his family through this tragedy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cocooned by the rain and three younger brothers who stood guard outside the long black car to ensure their privacy, the limo’s plush interior absorbed the scoffing noise Edward made. He breathed in his mother’s subtle perfume along with the musty dampness that clung to their clothes and took note of the slight tremor in her chilled fingers as they nested inside his broader, callused, scarred-up hand. He’d never been given much to romantic notions, not even before a killer bent on revenge had torn his life apart.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A year and a half ago Edward had been a damn good cop, one of the best undercover operatives KCPD’s drug enforcement division had ever put on the streets. Edward and his team had worked months to put one of Kansas City’s top cocaine suppliers out of business. Yet a technicality had allowed André Butler to walk away after a mistrial. Sure, Butler’s empire had been destroyed, his sources outed. But until a second trial could be mounted, the self-proclaimed modern gangster had walked out of the courthouse a free man—a free man looking for payback against the cop he’d trusted like a brother—a brother who had ultimately betrayed him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Butler had been released on December twenty-third. His first stop after spending the night with a girlfriend and stealing her car the next morning? Edward’s front yard. According to witnesses, Melinda had been building a snowman that day, keeping herself busy while Cara loaded presents into the car for the Kincaids’ traditional Christmas Eve get-together at his parents’ home. Butler had lured Melinda out to the street, shot Cara when she tried to protect their trusting little girl and then shot Melinda to silence her wailing cries over her fallen mother. Edward had been out to pick up a bicycle with training wheels for Melinda’s Christmas present when he got the call about Butler being spotted near his own address. He’d raced and skidded over slushy, snow-packed streets in a desperate effort to get to his family.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("By the time he turned the corner onto his block, Edward knew he was already too late. Butler ran to his car, turning his gun on Edward’s speeding SUV and firing off multiple shots. Edward prayed the bastard’s neck hadn’t snapped when he ran him down—that he’d died a slow, painful death. Though he’d barely felt it at the time, one of the bullets had cracked his windshield and pierced his chest, doing plenty of damage to his insides. Plowing over Butler, crashing through a line of parked cars and wrapping his engine around a tree had done even more. With both legs busted and his own blood leaving a crimson trail across the snow, Edward had crawled to the front sidewalk to try to breathe life back into the women he loved.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He’d taken out the bad guy, but he couldn’t save them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Merry Christmas.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Yeah, any romantic notions he might have once had were long gone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Edward?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His mother’s grip steadied as her soft voice jerked him back to the present. Why had he gone back to that morning? Too many beers had numbed his memory for too many months. But now that the physical mess of reclaiming sobriety had passed, every detail of that morning—every image, every hurt, every blame—stuck in his head with painful clarity.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He had no business being here, no business making this day any worse for his family than it already was. “Mom, I…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Edward tried to withdraw his hand, but Susan held on tight.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He stared down at their interlocking fingers, resting atop his thigh. He was supposed to say something now. Unlike smooth-talking Holden, or Atticus who’d always been smart enough to figure out what needed to be said, or even Sawyer, who led with his heart and blazed ahead and dealt with the consequences later, Edward wished he was eloquent enough to either compliment his mother’s strength or console her grief. But his instincts about such things were rusty from months of lonely isolation, and the right words wouldn’t come.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("They didn’t have to. Susan Kincaid hadn’t been married to a cop or raised four more for nothing. “I understand that you’re not ready to face a crowd of well-wishers. I’m sure the comparisons to Cara and Melinda’s funerals must be overwhelming. But it means everything to me that you made the effort to be here. For your family.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Was simply showing up really enough? He turned his head and looked down into the sincerity shining from her dark eyes. No wonder his father had loved this woman so much. Edward leaned over and kissed her cheek. “Atticus can be pretty darn convincing.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Susan stroked the neat, triangular flag that had been draped over his father’s coffin. Stress and sorrow had deepened the crow’s feet beside her eyes as she summoned a smile. “He doesn’t take no for an answer, does he.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Never has.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He’s stubborn, like your father. Smart like him, too.” Her smile faded into a wistful sigh. “Each of you has something of your father in him.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Edward absently twirled his dark walnut cane in his right hand in the heavy silence that followed. He was more steel pins than bone from the waist down, his heart and soul gutted. What part of John Kincaid did he have left in him?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His mother didn’t need to be intuitive to sense his discomfort. She leaned her cheek into his shoulder. “Holden obviously looks like your father—sings like him and has some of that Kincaid Irish charm in him, too. Sawyer has his heart—his gentleness, his compassion—he’s just as eager to right the wrongs of the world as your father was. And you…?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When she paused, Edward made a sound inside his chest that might once have been a laugh. “Hard to come up with something nice to say about me?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No. Hard to choose the right words to say so that you’ll believe them.” She turned in the seat to face him. “You’re the leader of this family now—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He shrugged away from her grasp and tried to retreat, but she simply followed him across the seat. “I know we’re all grownups. Your brothers are fine men and can take care of themselves. They’ve been taking care of "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("me")])]), _vm._v(" these past five days.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His mother deserved better than an absentee son during a time like this. He should have been stronger. He should have been able to deal with this. “I’m sorry, Mom. I should have called. I was busy—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Coming to grips with the loss of yet another person you love.” Laced with a gentle understanding he didn’t deserve, the touch of her hand against his jaw was almost painful. “You were busy getting sober.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("For a moment, his eyes locked onto hers. “How…?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her pale mouth curved into a smile. “Your clothes smell clean. You trimmed that ratty beard. Your beautiful eyes are clear.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“So I’m a bum who ignored my own mother in her time of need.” He turned away from her forgiving touch and intuitive gaze. “And you think "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("I’m")])]), _vm._v(" the leader of this family?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She brushed her fingers across his jaw again, ignoring his sardonic tone. “Your father would be so proud of you today.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He could pull away from the gentle touch, ignore the kind words. But the sheen of tears pooling in her eyes and spilling over did him in. Edward caught the first tear with the pad of his thumb and wiped the trail of sorrow from her cheek. “Mom…I…What are we supposed to do? Just because I’m the oldest doesn’t mean I can make sense of any of this. I can’t make this right.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But you can make it better. You "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("have")])]), _vm._v(" made it better, just by being here.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“In a way, I can see one good thing about the girls not being here—I don’t know how I’d explain losing Dad to Melinda. She loved her granddaddy so much. I’m not eight and I wasn’t born with Down’s syndrome. And I "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("still")])]), _vm._v(" don’t understand this.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“They were crazy about each other, weren’t they? John always called Melinda his little angel.” Susan Kincaid leaned her cheek into Edward’s hand. “I hadn’t remembered that. That’s a comfort to know they’ll be together again.” Wishing he had a handkerchief, Edward brushed away the new fall of tears. “Oh, Edward. I miss him so much.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Some comfort")])]), _vm._v(". His mother reached for him, caught him around the waist and hugged him tight. Edward reacted before he realized what the gesture might cost him. He wrapped his arms around her and held her close as his brittle defenses crumbled and her grief and confusion and anger flowed into his. “Just cry it on out, Mom. Just cry it out.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Several minutes passed before her sobbing sounds became erratic sniffles and then softened into steadier, more even breaths. His shirtfront was damp and streaked with her makeup as she finally pulled away. Her face became lined with a frown of confusion as her fingers probed the front waistband of his slacks. “You’re not wearing your badge.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His KCPD badge was locked in a metal box with his guns, gathering dust on the back shelf of his closet until he could decide if he would ever be ready to be a cop again. But that wasn’t what she wanted to hear. Kincaids were cops. The call to protect and serve was in their blood. That call had taken everything Edward loved. Today wasn’t the day to explain his guilt, however. A logical excuse would serve well enough. “I’ve been on leave since a year ago Christmas.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Confusion briefly morphed into maternal concern. “Your doctor cleared you to go back on duty, right?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“If I tended to my physical therapy the way I’m supposed to, then yeah, the doc says I could build up my strength and pass the physical. But I just don’t think I can….” He squeezed his fist around the brass carving on his cane. The stick of heavy walnut had become a mental crutch as much as an aid for the physical pain that would never completely leave his rebuilt joints. Images of Cara’s golden hair and Melinda’s effervescent smile blipped through his mind. His last mental snapshot of his family had seen that golden hair matted with blood and his daughter’s face lying pale and expressionless against the snow. He squeezed his eyes shut and tried to forget. But the task proved impossible, and he jerked his eyes open at his mother’s gentle touch on his face.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Shh.” Susan Kincaid stroked his cheek and hair as though he was her little boy again, and she could soothe his hurts away with a maternal magic that somehow managed to salvage some pride while still making him feel better. Though this was no skinned knee they were dealing with today. “I’m not asking you to do anything you’re not ready for. I have plenty enough to worry about on my plate. Your brothers are set on investigating your father’s murder themselves.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That doesn’t surprise me.” Sixteen months ago, he’d have been leading the pack to find the killer himself. “Don’t worry about them, Mom. The department has protocols in place. They won’t be able to play any official role in the case.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She arched one eyebrow as she pulled her hand away. “It’s their "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("unofficial")])]), _vm._v(" curiosity that concerns me. We all want to find the killer, we all want justice. But I don’t want to lose anyone else in the process—I don’t want this to impact their careers or their lives any more than it already has.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Edward nodded. “You want me to talk some sense into them? I don’t know that they’ll listen to me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“They’ll listen. They look up to you, son. They trust your wisdom about the world.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Mom, I—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Shh.” She pressed her fingers against his mouth, refusing to hear his protest. Right. He was the leader of the family now. Man, were they screwed. “Just…remind them to keep their wits about them. And to watch their backs.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His eyes settled on a strand of gray hair that had fallen over her cheek. The gray hadn’t been there the last time he’d seen her. The woman who’d been the Rock of Gibraltar for them throughout their lives was more vulnerable, more fragile than Edward had ever imagined. An inevitable sense of resignation—that call to duty that he’d tried to drink into a coma—awoke inside him. It was grouchy and unsure—and maybe even a bit afraid to take on the world again—but his mother’s need had reawakened it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Reaching out, Edward brushed the gray hair off her cheek and tucked it beneath the rich dark hair at her temple. “I’ll talk to them. I’ll help them however I can.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She blinked away another bout of tears and nodded her thanks. “And one more thing?” Why not? “I don’t have your father’s badge.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Edward tried to follow her unexpected tangent. Had it been buried with him? Did she want it back? Or had it simply been misplaced? “Where is it?” She shrugged. Okay. Not misplaced. “I’m sure the commissioner would issue a memorial copy—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No. You don’t understand.” Susan tugged at the front of Edward’s coat, then quickly smoothed it back into place. “I want the badge he carried with him as a detective and deputy commissioner for all these years. It was never recovered from the crime scene. I don’t know if it was lost during the struggle in the park when they kidnapped him from his morning run, or if one of those murderers kept it as some kind of souvenir.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Edward reached for his cane, certain that she was asking the wrong son for this favor. “Like I said, I haven’t been a cop for a while. Sawyer or Atticus could—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Edward. Please.” Her brown eyes darkened with her plea.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A muscle twitched beneath the scar on his jaw. He’d barely gotten himself to the cemetery. He’d already agreed to talking some cautionary sense into his brothers. He wasn’t equipped to ask questions or search for clues or go anywhere near a police investigation—not when the consequences for getting involved were so high.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I can’t have the man I love anymore. But he was truly one of Kansas City’s finest for thirty-six years. He left the military and became a police officer the year I found out I was pregnant with you. That badge represents the best years of our lives together. All that he did for this city, the man he was, the sons we raised. It represents so much more than just his job to me. Does that make any sense?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He’d packed away everything that represented his wife and child when he’d lost them. But one thing he’d taken to heart from those first few sessions with his trauma counselor—every person grieved in his or her own way. While he wanted to erase every painful reminder of loss from his life, his mother wanted to cling to the memories. Edward understood what she was asking of him. He understood that he was asking it of himself as well, though he couldn’t be sure how he was going to make it happen, or when, or what it might cost him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I want your father’s badge. If it takes two days or two years or forever to track it down, I want it back.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Okay.” That single word hurt—down deep in his soul. Even though this assignment was an unofficial one, he was going to be a cop again.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Okay? You’ll do that for me?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Edward wasn’t in any kind of shape to be making promises to anybody. But he made this one to his mother.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ll do it.”")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d9d4590","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kansascitychristmas_ch01.vue
// module id = 78
// module chunks = 0